import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import List from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import ListSubheader from '@material-ui/core/ListSubheader';
import InboxIcon from '@material-ui/icons/Add';

class DropDownList extends Component {
  state = {
    anchorEl: undefined,
    open: false,
    preview: false,
    previewImg: null,
    previewStyle: null,
  };

  handleClick = event => {
    if(this.props.disabled) {
      return;
    }
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = (item, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.setState({ open: false});
    if(item === -3) {
      this.props.openSetting();
      return;
    }
    if (this.props.onChange && item !== undefined && item !== null ) {
      this.props.onChange(item);
    }
  };

  thumbnailOnClickHandler = (img, e) => {
    // console.log('img: ',img)
    const rect = e.target.getBoundingClientRect();
    this.setState({preview: true, previewImg: (img.src || img), previewStyle: {left: rect.x + 'px', top: rect.y + 'px'}});

    e.preventDefault();
    e.stopPropagation();
  };

  render() {
    const {label, data, selectedItem, className, customHeader, style = {}, disabled, specialWidth} = this.props;

    let selectedItemName;
    /*
    const menuItems = data.map(option => {
      if(selectedItem !== undefined && option.id === selectedItem){
        selectedItemName = option.name
      }
      return <MenuItem key={option.id} style={{display:'block'}} selected={selectedItem ? option.id === selectedItem : false} onClick={this.handleRequestClose.bind(this, option.id)}>
        {option.name}
      </MenuItem>
    })
    */
    const menuItems = (<List>{data.filter( item => {
      if(item.custom) {
        return false;
      }
      return true;
    }).map((option, index) => {
      if(selectedItem !== undefined && option.id === selectedItem) {
        selectedItemName = option.name;
      }

      let img;
      if(option.hasOwnProperty('Photo-of-the-product') && option['Photo-of-the-product'] !== '') {
        img = option['Photo-of-the-product'];
      }
      if(option.hasOwnProperty('image') && option.image !== '') {
        img = option.image;
      }

      return (<MenuItem button key={(option.id === undefined ? index : option.id)} selected={selectedItem ? option.id === selectedItem : false} onClick={this.handleRequestClose.bind(this, option.id)}>
        {img ? <i className="fa fa-picture-o ico" aria-hidden="true" onClick={this.thumbnailOnClickHandler.bind(this, img)} ></i> : null}
        <ListItemText primary={option.name} />
      </MenuItem>);
    })}</List>);

    let customItems = data.filter( item => {
      if(item.custom) {
        return true;
      }
      return false;
    });

    const hasCustomItems = customItems && customItems.length;

    let divider;
    if(hasCustomItems) {
      customItems = (<List subheader={<ListSubheader>{customHeader}</ListSubheader>}>{customItems.map((option, index) => {
        if(selectedItem !== undefined && option.id === selectedItem) {
          selectedItemName = option.name;
        }
        return (<MenuItem button key={(option.id === undefined ? index : option.id)} selected={selectedItem ? option.id === selectedItem : false} onClick={this.handleRequestClose.bind(this, option.id)}>
          {option.id === -3 ? <ListItemIcon>
            <InboxIcon style={{marginRight: -10 + 'px', color: '#d20000'}} />
          </ListItemIcon> : null}
          {option.id === -3 ? <ListItemText classes={{root: 'dropdownlist-create-new-custom-item'}} primary={option.name} />
          : <ListItemText primary={option.name} /> }
        </MenuItem>);
      })}</List>);
      divider = <Divider />;
    }

    return (
      <div className={'dropdownlist ' + (className ? className : '')} style={style} onClick={this.handleClick}
          aria-owns={this.state.open ? 'simple-menu' : null}
          aria-haspopup="true">
        {label ? <div className="topic">
            <label>{label}</label>
          </div> : null }

        {disabled ?
          <div
            className="text">
            <h5 style={{color: '#BDBDBD'}}>{selectedItemName}</h5>
          </div> :
          <div
            className="text" >
            <h5>{selectedItemName}</h5>
          </div>
        }

        { !disabled &&
          <div className="opener">
            <div className="btn">
              <i className="fa fa-chevron-down"></i>
            </div>
          </div>
        }

        {!disabled &&
          <Menu
              id="long-menu"
              anchorEl={this.state.anchorEl}
              open={this.state.open}
              // MUI v4 "selectedMenu" variant can align the popover based on the selected item,
              // which looks like the menu is opening "up in the page" for long/scrollable lists.
              // "menu" keeps the alignment relative to the anchorEl instead.
              variant="menu"
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              onClose={this.handleRequestClose.bind(this, null)}
              MenuListProps={{
                style: {
                  width: specialWidth || 340,
                  maxHeight: 400
                },
              }}
            >
              {menuItems}
              {hasCustomItems ? divider : null}
              {hasCustomItems ? customItems : null}
          </Menu>
        }

        <div className="bottom-bar" />
        {this.state.preview ? <div className="img-preview" onClick={()=>{this.setState({preview: false, previewImg: null});}}><img src={this.state.previewImg} style={this.state.previewStyle} /></div> : null}
      </div>
    );
  }
}

DropDownList.propTypes = {

  disabled: PropTypes.any,
  openSetting: PropTypes.any,
  onChange: PropTypes.any,
  label: PropTypes.any,
  data: PropTypes.any,
  selectedItem: PropTypes.any,
  className: PropTypes.any,
  customHeader: PropTypes.any,
  style: PropTypes.any,
  specialWidth: PropTypes.any,
};
// label: PropTypes.string,

export default DropDownList;
